<p-dialog
  [header]="translationKeys.articleCategorySelectDialogComponent.html.dialogTitle | translate"
  [(visible)]="showDialog"
  [modal]="true"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="category-dialog"
  (onHide)="cancelEvent.emit()"
  contentStyleClass="scip-dialog-content"
>
  <div style="height: 100%; min-height: 300px; display: flex; justify-content: center">
    <div style="flex: 1 1 60%" class="table-column">
      <scip-article-category-tree (nodeSelected)="setSelectedNode($event)" [selectedNode]="selectedLeftNode"></scip-article-category-tree>
    </div>
    <div style="flex: 0" class="category-selection-button-column">
      <button
        avanoButton
        icon="icon-content-chevron-right"
        [disabled]="!selectedLeftNode"
        class="category-selection-button"
        (click)="transferSelection()"
      ></button>
      <button
        avanoButton
        icon="icon-content-chevron-left"
        [disabled]="!selectedRightNode"
        class="category-selection-button"
        (click)="removeSelectedNode()"
      ></button>
      <button
        avanoButton
        icon="icon-content-chevron-all-left"
        [disabled]="!selectedCategories?.length"
        class="category-selection-button"
        (click)="removeAll()"
      ></button>
    </div>
    <div style="flex: 1 1 30%">
      <avano-table [headerText]="translationKeys.articleCategorySelectDialogComponent.html.selectedArticleCategories | translate" [tableRef]="selectedArticleCategoriesTable">
        <div style="display: flex" class="table-column">
          <p-table #selectedArticleCategoriesTable [value]="selectedCategories" selectionMode="single" [selection]="selectedRightNode" (selectionChange)='setSelectedArticleCategoryRight($event)' [scrollable]="true" scrollHeight="flex">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ translationKeys.articleCategorySelectDialogComponent.html.articleCategories | translate }}</th>
                <th>{{ translationKeys.articleCategorySelectDialogComponent.html.tariffTaricCode | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-selectedNode>
              <tr [pSelectableRow]="selectedNode">
                <td><div avanoEllipsis>{{ selectedNode.text }}</div></td>
                <td>{{ selectedNode.categorySpecificIdentifier }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </avano-table>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.cancel | translate"
      icon="icon-content-cancel"
      (click)="cancelEvent.emit()"
    ></button>
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="translationKeys.commonTranslationKey.btn.apply | translate"
      icon="icon-content-add"
      (click)="saveEvent.emit(selectedCategories)"
    ></button>
  </ng-template>
</p-dialog>
